import React from 'react'

import PhoneLink from './../items/static/phoneLink'

import styles from './footer.module.scss'

const SignInFooter = () => {
  return (
    <footer className={styles.signInFooter}>
      <p className={styles.copy}>GPS/GLONASS система мониторинга Транснавигатор © {new Date().getFullYear()}</p>
      <p className={styles.support}>
        Техническая поддержка:
        <PhoneLink title="+375 (17) 282-00-92" link="+375172820092" />,
        <PhoneLink title="+375 (17) 277-24-04" link="+375172772404" />,
        <PhoneLink title="+375 (29) 190-64-55" link="+375291906455" />
      </p>
    </footer>
  )
}

export default SignInFooter